import React from 'react';

export default function IconChartbit() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.333 4H10.333C9.78072 4 9.33301 4.44772 9.33301 5V11C9.33301 11.5523 9.78072 12 10.333 12H12.333C12.8853 12 13.333 11.5523 13.333 11V5C13.333 4.44772 12.8853 4 12.333 4Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66638 4.66663H3.66638C3.1141 4.66663 2.66638 5.11434 2.66638 5.66663V10.3333C2.66638 10.8856 3.1141 11.3333 3.66638 11.3333H5.66638C6.21867 11.3333 6.66638 10.8856 6.66638 10.3333V5.66663C6.66638 5.11434 6.21867 4.66663 5.66638 4.66663Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 1.33337V4.00004"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 12.0067V14.6734"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.65979 2.33337V4.66671"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.65979 11.34V13.6733"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
